import { h, Component } from 'preact'
import { Router } from 'preact-router'
import styled from 'styled-components'

import Spinner from './components/visual/Spinner'
import PoliticianPage from './components/PoliticianDetail/PoliticianPage'
import PoliticianListPage from './components/PoliticianList/PoliticianListPage'

// import Home from 'async!./home';
// import Profile from 'async!./profile';

const Content = styled.div`
  padding-top: 130px;
  height: 100%;
`

const FullScreen = styled.div`
  height: 100%;
`

export default class App extends Component {
  state = {
    props:
      typeof document !== 'undefined'
        ? JSON.parse(document.getElementById('props').innerHTML)
        : null,
  }

  /** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
  handleRoute = e => {
    /* global dataLayer */
    if (typeof dataLayer !== 'undefined') {
      console.log(e.url, 'dataLayer.push({ event: "page" })')
      dataLayer.push({ event: 'page' })
    }
  }

  render() {
    const { props } = this.state
    if (
      process.env.NODE_ENV !== 'production' &&
      (!props || props.devel) &&
      typeof fetch !== 'undefined'
    ) {
      fetch(`${`${window.location}`.split('?')[0]}/props.json`)
        .then(r => r.json())
        .then(v => {
          this.setState({ props: v })
        })
    }
    if (!props || props.devel) return <Spinner />

    return (
      <FullScreen>
        <Content>
          <Router onChange={this.handleRoute}>
            <PoliticianPage path="/cs/seznam-politiku/:sub" {...props} />
            <PoliticianListPage path="/cs/seznam-politiku/" {...props} />
          </Router>
        </Content>
      </FullScreen>
    )
  }
}



// WEBPACK FOOTER //
// ./app.js